var map = {
	"./ai-logo.svg": 177,
	"./css-logo.png": 131,
	"./html-logo.png": 128,
	"./javascript-logo.png": 648,
	"./mongodb-logo.svg": 798,
	"./nextjs-logo.svg": 68,
	"./node-logo.png": 783,
	"./postgresql-logo.svg": 903,
	"./python-logo.svg": 981,
	"./react-logo.png": 394,
	"./redis-logo.svg": 516,
	"./typescript-logo.svg": 826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 777;